import { UserList } from '@/users/UserList'

export function Users() {
  return <UserList />
}
